@if (
  (isContentWidget() ||
    activeWidget?.widget?.context === 'external' ||
    indicatorDataStore.dataLayerTypeHasData(
      activeWidget?.widget?.dataLayerType || ''
    )) &&
    activeWidget?.widget;
  as config
) {
  <p-accordion
    [activeIndex]="1"
    class="w-full"
    expandIcon="fas fa-chevron-down"
    collapseIcon="fas fa-chevron-up">
    @if (config.indicators; as indicatorIds) {
      <p-accordionTab [disabled]="indicatorIds.length === 0">
        <ng-template pTemplate="header">
          <div class="flex gap-2 align-items-center w-full">
            <span>Indikatoren anordnen</span>
            <p-badge
              class="ml-auto text-xs"
              [value]="indicatorIds.length"></p-badge>
          </div>
        </ng-template>
        <app-indicator-selection-list
          [indicatorIds]="indicatorIds"
          [wegweiser]="config.context !== 'local'"
          (dropEvent)="updateIndicatorSelection($event)"
          (unselectEvent)="
            config.context === 'local'
              ? toggleIndicatorSelection($event)
              : toggleWegweiserIndicatorSelection($event)
          "
          [captions]="
            activeWidget?.type === 'map'
              ? [{ label: 'Indikator auf Karte', icon: 'fas fa-map' }]
              : activeWidget?.type === 'bubble'
                ? [
                    null,
                    null,
                    { label: 'Radius Indikator', icon: 'fas fa-ruler' },
                  ]
                : []
          "></app-indicator-selection-list>
      </p-accordionTab>
    }
    @if (activeWidget?.widget?.context !== 'external') {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex align-items-center gap-2 w-full">
            <span>Indikatorenauswahl</span>
            <p-button
              class="ml-auto"
              (click)="setSelectionMode('tree', $event)"
              size="small"
              severity="primary"
              [text]="mode === 'list'"
              [rounded]="true"
              icon="fas fa-folder-tree"></p-button>
            <p-button
              (click)="setSelectionMode('list', $event)"
              size="small"
              severity="primary"
              [text]="mode === 'tree'"
              [rounded]="true"
              icon="fas fa-list"></p-button>
          </div>
        </ng-template>

        @if (mode === 'tree') {
          <app-atlas-indicator-tree
            [combineableIndicatorIds]="combineableIndicatorIds"
            [min]="
              selectionMode === 'double'
                ? 2
                : selectionMode === 'triple'
                  ? 3
                  : 1
            "
            [max]="
              selectionMode === 'double'
                ? 2
                : selectionMode === 'triple'
                  ? 3
                  : 999
            "
            (selectIndicator)="
              toggleIndicatorSelection($event)
            "></app-atlas-indicator-tree>
        } @else {
          <app-indicator-list
            (selectIndicator)="
              toggleIndicatorSelection($event)
            "></app-indicator-list>
        }
      </p-accordionTab>
    } @else {
      @if (wegweiserStore.indicatorsAsTree(); as wegweiserTree) {
        <p-accordionTab>
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-2 w-full">
              <span>Indikatoren (Wegweiser Kommune)</span>
            </div>
          </ng-template>
          <app-atlas-indicator-tree
            [overrideTree]="wegweiserTree"
            (selectIndicator)="
              toggleWegweiserIndicatorSelection($event)
            "></app-atlas-indicator-tree>
        </p-accordionTab>
      }
    }
  </p-accordion>
} @else {
  <app-alert severity="info" [canToggle]="false" styleClass="p-3">
    Keine Indikatoren für die aktuelle Auswahl vorhanden.
  </app-alert>
}
